import { Flex, PrimaryButton, Typography } from '@banhala/ui-kit';
import { bridge } from 'shared/src/utils';
import { useLogClickSignUpForFolder } from '../hooks/useLogClickSignUpForFolder';

/**
 * 비회원(`myInfo.is_anonymous === true`)일 때 LikeGoods 최상단에 노출되는 회원가입 유도 배너.
 * iOS `LikedLoginView` / `LikedProductUserRegisterCell` 대응.
 */
export const LikedGoodsLoginBanner = () => {
  const logClick = useLogClickSignUpForFolder();
  const handlePress = () => {
    logClick();
    bridge.assertLogin({});
  };

  return (
    <Flex
      padding={{ horizontal: 16, vertical: 16 }}
      backgroundColor={'bg_primary'}
    >
      <Flex.Row
        alignItems={'center'}
        gap={8}
        padding={{ horizontal: 16, vertical: 12 }}
        backgroundColor={'white'}
        borderRadius={10}
        shadowStep={'small'}
        onPress={handlePress}
      >
        <Typography type={'subtitle2'}>🔑</Typography>
        <Flex flex={1}>
          <Typography type={'subtitle3'} color={'content_secondary'}>
            {'회원가입을 하시면 나만의\n서랍을 만드실 수 있어요!'}
          </Typography>
        </Flex>
        <PrimaryButton
          color={'blue'}
          size={'small'}
          outline
          onPress={handlePress}
        >
          회원가입
        </PrimaryButton>
      </Flex.Row>
    </Flex>
  );
};
